export const isLocalhost = () => window.location.href.includes('localhost');